import { render } from "./Home.vue?vue&type=template&id=18524b21"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\projects\\tahdir-v2\\tahdir-students-scan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__